import script from "./AdminLoginTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLoginTemplate.vue?vue&type=script&setup=true&lang=js"

import "./AdminLoginTemplate.vue?vue&type=style&index=0&id=6dd98f0b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dd98f0b"]])

export default __exports__